import { render } from "./legoListItem.vue?vue&type=template&id=ed158c2a"
import script from "./legoListItem.vue?vue&type=script&lang=js"
export * from "./legoListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/element/legoList/legoListItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ed158c2a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ed158c2a', __exports__)) {
    api.reload('ed158c2a', __exports__)
  }
  
  module.hot.accept("./legoListItem.vue?vue&type=template&id=ed158c2a", () => {
    api.rerender('ed158c2a', render)
  })

}


export default __exports__